import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

/** Reserves space for the source, summary and collapsed section rows below the card heading. */
export const InferredProjectCardSkeleton = ({ label }: { label: string }): React.JSX.Element => (
	<>
		<VisuallyHidden role="status">{label}</VisuallyHidden>
		<Stack space="space.200" aria-hidden="true" testId="inferred-project-card-skeleton">
			<Skeleton width="100%" height={96} borderRadius={token('radius.medium')} />
			<Stack space="space.100">
				<Skeleton width="100%" height={16} />
				<Skeleton width="100%" height={16} />
				<Skeleton width="100%" height={16} />
				<Skeleton width="75%" height={16} />
			</Stack>
			<Stack space="space.200">
				<Skeleton width="65%" height={24} />
				<Skeleton width="55%" height={24} />
			</Stack>
		</Stack>
	</>
);
